"use client";

import { useEffect, useState } from "react";

const getSize = (size: any) => {
  if (size !== "undefined") {
    if (size > 1024) {
      return "default";
    }

    if (size >= 768) {
      return "table";
    }

    return "mobile";
  }
  return "default";
};

const getTwSize = (size: any): TwSize => {
  if (size !== "undefined") {
    if (size >= 1400) {
      return "3xl";
    }
    if (size >= 1360) {
      return "2xl";
    }
    if (size >= 1280) {
      return "xl";
    }
    if (size >= 1024) {
      return "lg";
    }
    if (size >= 768) {
      return "md";
    }
    if (size >= 640) {
      return "sm";
    }
    if (size >= 480) {
      return "xs";
    }
    return "xs";
  }
  return "xl";
};

export type Size = "default" | "mobile" | "table";
export type TwSize = "sm" | "md" | "lg" | "xl" | "2xl" | "xs" | "3xl";

export function useResize(): { size: Size; width: number; twSize: TwSize } {
  const [size, setSize] = useState<Size>(() => {
    return getSize(window.innerWidth);
  });

  const [twSize, setTwSize] = useState<TwSize>(() => {
    return getTwSize(window.innerWidth);
  });

  const [width, setWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    if (!window) {
      return () => {};
    }
    function resize() {
      const s = getSize(window.innerWidth);
      setSize(s);
      setTwSize(getTwSize(window.innerWidth));
      setWidth(window.innerWidth);
    }
    resize();
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  return { size, width, twSize };
}
